import React from "react";
import { Link } from "react-router-dom";
import { useRoute } from "@/routes/getRoute";
import { ChatUser } from "@zeemee/react-web-chat";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export const ChatUserDisplayWrapper = ({
  user,
  children,
}: {
  user: ChatUser;
  children: React.ReactNode;
}) => {
  const getRoute = useRoute();
  const { t } = useTranslation();

  if (user.__typename !== "Student") {
    return (
      <button
        onClick={() =>
          toast.error(t("chat.chatUserDisplayWrapper.notStudentTitle"), {
            description: t("chat.chatUserDisplayWrapper.notStudentText"),
            action: {
              label: t("global.close"),
              onClick: () => {
                // Close action - no additional logic needed
              },
            },
          })
        }
      >
        {children}
      </button>
    );
  }

  return (
    <Link to={getRoute("student", { studentId: user.id })}>{children}</Link>
  );
};
